import React from "react";

const Header = () => {
  return <h2 className="header">Expense Tracker</h2>;
};

export default Header;
